/**
 * Shortens `text` to at most `maxLen` characters by replacing the middle with an ellipsis (…).
 */
export const truncateMiddle = (text: string, maxLen: number): string => {
  if (text.length <= maxLen) {
    return text;
  }
  const half = Math.floor((maxLen - 3) / 2);
  return `${text.slice(0, half)}…${text.slice(text.length - half)}`;
};
